<template>
    <CompanyDetails/>
</template>
<script>
import CompanyDetails from '../../components/companies/CompanyDetails';
import store from '../../store/store';

export default {
  components: {
    CompanyDetails,
  },
  beforeRouteLeave: (to, from, next) => {
    store.commit('companies/companyId', null);
    next();
  },
};
</script>
